import { render, staticRenderFns } from "./ProcessStoryModal.vue?vue&type=template&id=68694a67"
import script from "./ProcessStoryModal.vue?vue&type=script&lang=js"
export * from "./ProcessStoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports